import { Camera, CameraResultType } from '@capacitor/camera';
import { IonAvatar, IonButton, IonButtons, IonCard, IonCardContent, IonCol, IonContent, IonFab, IonFabButton, IonFooter, IonGrid, IonHeader, IonIcon, IonImg, IonInput, IonItem, IonLabel, IonMenuButton, IonPage, IonRefresher, IonRefresherContent, IonRow, IonSelect, IonSelectOption, IonSkeletonText, IonSpinner, IonThumbnail, IonTitle, IonToolbar, RefresherEventDetail, useIonAlert, useIonRouter, useIonToast, useIonViewDidEnter, useIonViewWillEnter } from '@ionic/react';
import { addCircleOutline, cameraOutline, carOutline, chevronBackOutline, refreshOutline, removeCircleOutline, trashOutline } from 'ionicons/icons';
import React, {  useState } from 'react';
import { useParams } from 'react-router-dom';
import InitialsAvatar from 'react-initials-avatar';
import 'react-initials-avatar/lib/ReactInitialsAvatar.css';
import { useAppContext } from '../AppProvider';

interface RouteParams {
    token: string;
}

const VehicleEdit: React.FC = () => {
    const [uploading, setUploading] = useState<boolean>(false);
    const [Vehicle, setVehicle] = useState<any>({});
    const [yearOptions, setYearOptions] = useState<any>([]);
    const [vehiclePhoto, setVehiclePhoto] = useState<string>('');
    const [mfgEdit, setMfgEdit] = useState<boolean>(false);
    const [modelEdit, setModelEdit] = useState<boolean>(false);
    const [colorEdit, setColorEdit] = useState<boolean>(false);
    const [licenseEdit, setLicenseEdit] = useState<boolean>(false);

    const { authKey, authenticateMember, setShowLoader, settings, states, getStates, SWFullHorizLogo, SWTextDarkLogo, fadeInImage, showToast } = useAppContext();
    
    const [showAlert] = useIonAlert();
    const { token } = useParams<RouteParams>();
    const router = useIonRouter();
    
    const vehiclePhotoPath = '//api.besolowise.com/vehicles/photos/files/';  

    //
    // Authenticate Member
    //
    useIonViewWillEnter(() => { 
        setShowLoader(true);
        const authenticate = async () => {
            const authenticated = await authenticateMember();         
            if(!authenticated.mt) router.push('/login', 'forward');
            else {
                await getVehicle(token, authenticated.mt);
                setShowLoader(false);
            }
        };
        authenticate();
    }); 
    

    const toggleMfgForm = () => setMfgEdit(!mfgEdit);
    const toggleModelForm = () => setModelEdit(!modelEdit);
    const toggleColorForm = () => setColorEdit(!colorEdit);
    const toggleLicenseForm = () => setLicenseEdit(!licenseEdit);

    
    const getVehicle = async (vt: string, mt: string) => {
        getYears(); 
        getStates(); 
        try {
            const formData = new FormData();
            formData.append('mt', mt);
            formData.append('vt', vt);
            const response = await fetch('https://api.besolowise.com/vehicles/get/', {
                method: 'POST',
                credentials: 'include',
                body: formData
            });
            
            if(response.ok) {
                const obj = await response.json();
                if(typeof obj.vehicleID == 'number') {
                    setVehicle(obj); 
                    const date = new Date();
                    const time = date.getTime();
                    //setVehiclePhoto(vehiclePhotoPath + `${obj.vehiclePhoto}` + '?v=' + time);
                    setVehiclePhoto(obj.vehiclePhotoUrl);
                } else {
                    setShowLoader(false);
                    showToast({
                        message: 'Data Error',
                        duration: 2000,
                        color: 'danger',
                        position: 'middle'
                    });
                }
            } else {
                setShowLoader(false);
                showToast({
                    message: 'Response Error',
                    duration: 2000,
                    color: 'danger',
                    position: 'middle'
                });
            }
        } catch(error) {
            setShowLoader(false);
            showToast({
                message: 'Connection Error: ' + error + '. Refresh this page to try again.',
                duration: 3000,
                color: 'danger',
                position: 'middle'
            });
        }       
    };

    const takePhoto = async (e: any) => {
        const target = e.target;
        try {
            const photo = await Camera.getPhoto({
                quality: 99,
                allowEditing: false,
                resultType: CameraResultType.Base64,
            });
            const img = `data:image/jpeg;base64,${photo.base64String}`;
            updateVehiclePhoto(img);
        } catch (error) {
            console.log('Photo cancelled');
         }
    };

    const updateVehiclePhoto = async (imageData: string) => {
        setUploading(true);
        const btn: any = document.getElementById('addPhoto');
        btn.setAttribute('disabled', '');
        const formData = new FormData();
        const blob = await (await fetch(imageData)).blob();
        formData.append('token', token);
        formData.append('formName', 'photoForm');
        formData.append('vehiclePhoto', blob, 'temp-image.jpg');
        formData.append('mt', authKey.mt);
    
        try {
            const response = await fetch('https://api.besolowise.com/vehicles/update/', {
                method: 'POST',
                body: formData,
                credentials: 'include',
            });
            
            if(response.ok) {
                const obj = await response.json();
                //console.log(obj);
               
                if(obj.success) {
                    await getVehicle(token, authKey.mt);            
                    
                    showToast({
                        message: 'Your photo was updated',
                        duration: 2000,
                        color: 'success',
                    });
                } else {
                    showToast({
                        message: 'Data Error: Image upload failed. '+ obj.message,
                        duration: 5000,
                        color: 'danger',
                    });
                }
            } else {
                showToast({
                    message: 'Response Error: Image upload failed',
                    duration: 5000,
                    color: 'danger',
                });
            }
        } catch (error) {
          showToast({
            message: 'Connection Error: ' + error,
            duration: 3000,
            color: 'danger',
          });
        }
        btn.removeAttribute('disabled');
        setUploading(false);
    };

    const rotatePhoto = async (e: any) => {
        const btn: any = document.getElementById('rotatePhoto');
        btn.setAttribute('disabled', '');
        const file =  `${Vehicle.vehiclePhoto}`;
        const formData = new FormData();
        formData.append('file', file);
        formData.append('mt', authKey.mt);

        try {            
            const response = await fetch('https://api.besolowise.com/vehicles/photos/rotate/', {
                method: 'POST',
                credentials: 'include',
                body: formData
            });
            
            if(response.ok) {
                const obj = await response.json(); 
                btn.removeAttribute('disabled');
                if(obj.success) await getVehicle(token, authKey.mt);
                else {
                    showToast({
                        message: 'Data Error',
                        duration: 2000,
                        color: 'danger',
                    });
                }
            } else {
                btn.removeAttribute('disabled');
                showToast({
                    message: 'Response Error',
                    duration: 2000,
                    color: 'danger',
                });
            }
        } catch (error) {
            btn.removeAttribute('disabled');
            showToast({
              message: 'Connection Error: ' + error,
              duration: 3000,
              color: 'danger',
            });
        }
    };

    const deletePhoto = async (e: any) => {        
        const field = 'vehiclePhoto';
        const file =  `${Vehicle.vehiclePhoto}`;
        showAlert({
            header: 'Confirm!',
            message: 'Are you sure you want to DELETE this photo?',
            buttons: [
                { text: 'Cancel', 
                  role: 'cancel',
                  cssClass: 'alert-button-cancel', 
                },
                {
                    text: 'Delete',
                    role: 'confirm',
                    cssClass: 'alert-button-confirm', 
                    handler: async () => {
                        const formData = new FormData();
                        formData.append('field', field);
                        formData.append('file', file);
                        formData.append('token', token);
                        formData.append('mt', authKey.mt);

                        try {
                            const response = await fetch('https://api.besolowise.com/vehicles/photos/delete/', {
                                method: 'POST',
                                credentials: 'include',
                                body: formData
                            });

                            if(response.ok) {
                                const obj = await response.json(); 
                                if(obj.success) {
                                    await getVehicle(token, authKey.mt);
                                    showToast({
                                        message: 'Success! Photo was deleted.',
                                        duration: 2000,
                                        color: 'success',
                                    });
                                } else {
                                    showToast({
                                        message: 'Data Error: Photo was not deleted. Try again.',
                                        duration: 2000,
                                        color: 'danger',
                                    });
                                }
                            } else {
                                showToast({
                                    message: 'Response Error: Photo was not deleted. Try again.',
                                    duration: 3000,
                                    color: 'danger',
                                    position: 'middle'
                                });
                            }
                        } catch (error) {
                            showToast({
                                message: 'Connection Error: Photo was not deleted. ' + error + ' Try again.',
                                duration: 3000,
                                color: 'danger',
                            });
                        }
                    }
                }
            ]
        })        
    };

    const updateVehicle = async (e: any) => {
        e.preventDefault();
        const form = e.target; 
        const formName = form.name;
        const btn: any = document.getElementById(formName + 'Submit');
        btn.innerHTML = 'Saving...';
        btn.setAttribute('disabled', '');
        const formData = new FormData(form);
        formData.append('formName', formName);
        formData.append('token', token);
        formData.append('mt', authKey.mt);

        try {
            const response = await fetch('https://api.besolowise.com/vehicles/update/', {
                method: 'POST',
                credentials: 'include',
                body: formData
            });
            if(response.ok) {
                const obj = await response.json(); 
                if(obj.success) {
                    await getVehicle(token, authKey.mt);
                    btn.innerHTML = 'Save';
                    btn.removeAttribute('disabled');
                    document.getElementById(formName + 'Cancel')?.click();
                    showToast({
                        message: 'Success!',
                        duration: 2000,
                        color: 'success',
                    });
                } else {
                    btn.innerHTML = 'Save';
                    btn.removeAttribute('disabled');
                    showToast({
                        message: 'Error: ' + obj.message,
                        duration: 3000,
                        color: 'danger',
                    });
                }
            } else {
                btn.innerHTML = 'Save';
                btn.removeAttribute('disabled');
                showToast({
                    message: 'Response Error',
                    duration: 3000,
                    color: 'danger',
                });
            }              
        } catch(error) {
            btn.innerHTML = 'Save';
            btn.removeAttribute('disabled');
            showToast({
                message: 'Connection Error: ' + error,
                duration: 3000,
                color: 'danger',
            });
        } 
    };

    const deleteVehicle = () => {
        showAlert({
            header: 'Confirm!',
            message: 'Are you sure you want to REMOVE this Vehicle?',
            buttons: [
                { text: 'Cancel', 
                  role: 'cancel',
                  cssClass: 'alert-button-cancel', 
                },
                {
                    text: 'Delete',
                    role: 'confirm',
                    cssClass: 'alert-button-confirm',
                    handler: async () => {
                        try {
                            const formData = new FormData();
                            formData.append('token', token);
                            formData.append('mt', authKey.mt);
                            const apiURI = 'https://api.besolowise.com/vehicles/delete/';
                            const response = await fetch(apiURI, {
                                method: 'POST',
                                credentials: 'include',
                                body: formData
                            });
                            if(response.ok) {
                                const obj = await response.json(); 
                                if(obj.success) {
                                    router.push('/account/vehicles', 'back');
                                }  else {
                                    showToast({
                                        message: 'Data error.',
                                        duration: 2000,
                                        color: 'danger',
                                    });
                                }
                            } else {
                                showToast({
                                    message: 'Response Error: Vehicle was not deleted',
                                    duration: 2000,
                                    color: 'danger',
                                });
                            }
                        } catch(error) {
                            showToast({
                                message: 'Connection Error: ' + error,
                                duration: 2000,
                                color: 'danger',
                            });
                        }  
                    }
                }
            ]
        })
    };

    const getYears = async () => {
        // Fill 'vehicleYear' options
        const today = new Date();
        const thisYear = today.getFullYear();
        const start = thisYear + 1;
        const end = thisYear - 60;
        const yearsOptions = [];
        for(let y = start; y >= end; y--) yearsOptions.push(y.toString());
        setYearOptions(yearsOptions); 
    };

    const handleRefresh = (event: CustomEvent<RefresherEventDetail>) => {
        //setLoading(true);
        setTimeout(async () => {
            await getVehicle(token, authKey.mt);
            event.detail.complete();
            //setLoading(false);
        }, 2000);
    };

    return (
        <IonPage>
            <IonHeader>
                <IonToolbar>
                    <IonButtons slot='start'>
                        <IonButton color={'tertiary'} routerDirection='back' routerLink='/account/vehicles'>Vehicles</IonButton>
                    </IonButtons>
                    <IonTitle><IonImg className='headerTextLogo' src={settings.theme == '1' ? SWTextDarkLogo : SWFullHorizLogo}></IonImg></IonTitle>
                    <IonButtons slot='end'>
                        <IonMenuButton color={'tertiary'} />
                    </IonButtons>
                </IonToolbar>
            </IonHeader>
            <IonContent className="ion-padding account-content-bg" id="VehicleContent">

                <IonRefresher slot="fixed" onIonRefresh={handleRefresh}>
                    <IonRefresherContent></IonRefresherContent>
                </IonRefresher>

                <IonGrid>
                    <IonRow>
                        <IonCol size='12'>
                            <h1><IonIcon className='m-hide' color={'secondary'} icon={carOutline}></IonIcon> 
                                {Vehicle.vehicleYear} {Vehicle.vehicleMfg}
                                <br /><span>Editing a Saved Vehicle</span>
                            </h1>                            
                        </IonCol>
                    </IonRow>
                </IonGrid>

                <IonCard>                    
                    <IonCardContent>    
                        <IonLabel color={'dark'} onClick={toggleMfgForm}><b>Year & Manufacturer</b> <em className='required'>Required</em></IonLabel>
                        { mfgEdit
                            ? (<form name='mfgForm' onSubmit={updateVehicle}>
                                    <IonGrid>
                                        <IonRow>
                                            <IonCol size='6'>     
                                                <IonSelect fill='outline' labelPlacement='stacked' name='vehicleYear' placeholder='Year' value={Vehicle.vehicleYear}>                                     
                                                    <IonSelectOption value=''>Year</IonSelectOption>
                                                    {yearOptions.map((year:string, index:number) => (
                                                        <IonSelectOption key={index} value={year}>{year}</IonSelectOption>
                                                    ))}
                                                </IonSelect>
                                            </IonCol>
                                            <IonCol size='6'>
                                                <IonInput fill='outline' name='vehicleMfg' placeholder='Name' type='text' value={Vehicle.vehicleMfg}></IonInput>                                                
                                            </IonCol>
                                        </IonRow>
                                    </IonGrid>
                                    <IonButton className='ion-margin-top' color={'medium'} id='mfgFormCancel' onClick={toggleMfgForm}>Cancel</IonButton>
                                    <IonButton className='ion-margin-top' color={'secondary'} id='mfgFormSubmit' type='submit'>Save</IonButton>
                                </form>) 
                            : <p onClick={toggleMfgForm}>{Vehicle.vehicleYear} {Vehicle.vehicleMfg}</p>
                        }  
                    </IonCardContent>
                </IonCard>
                
                <IonCard>                    
                    <IonCardContent>       
                        <IonLabel color={'dark'} onClick={toggleModelForm}><b>Model</b> <em className='required'>Required</em></IonLabel>                 
                        { modelEdit 
                            ? (<form name='modelForm' onSubmit={updateVehicle}>
                                    <IonInput fill='outline' name='vehicleModel' placeholder='Model' type='text' value={Vehicle.vehicleModel}></IonInput>
                                    <IonButton className='ion-margin-top' color={'medium'} id='modelFormCancel' onClick={toggleModelForm}>Cancel</IonButton>
                                    <IonButton className='ion-margin-top' color={'secondary'} id='modelFormSubmit' type='submit'>Save</IonButton>
                                </form>)                                                     
                            : <p onClick={toggleModelForm}>{Vehicle.vehicleModel == '' ? 'Not Recorded' : Vehicle.vehicleModel}</p>
                        }
                    </IonCardContent>
                </IonCard>
                
                <IonCard>                    
                    <IonCardContent>    
                        <IonLabel color={'dark'} onClick={toggleColorForm}><b>Color & Trim</b></IonLabel>                    
                        { colorEdit 
                            ? (<form name='colorForm' onSubmit={updateVehicle}>
                                    <IonGrid>
                                        <IonRow>
                                            <IonCol sizeXs='12' sizeSm='12'>
                                                <IonInput fill='outline' name='vehicleColor' placeholder='Color' type='text' value={Vehicle.vehicleColor}></IonInput>
                                            </IonCol>                      
                                        </IonRow>
                                    </IonGrid>
                                    <IonButton className='ion-margin-top' color={'medium'} id='colorFormCancel' onClick={toggleColorForm}>Cancel</IonButton>
                                    <IonButton className='ion-margin-top' color={'secondary'} id='colorFormSubmit' type='submit'>Save</IonButton>
                                </form>)                                                     
                            : <p onClick={toggleColorForm}>{(Vehicle.vehicleColor == '') ? 'Not Recorded' : Vehicle.vehicleColor}</p>
                        }
                    </IonCardContent>
                </IonCard>
                
                <IonCard>
                    <IonCardContent>
                        <IonLabel color={'dark'} onClick={toggleLicenseForm}><b>License Plate</b></IonLabel>
                        { licenseEdit 
                            ? (<form name='licenseForm' onSubmit={updateVehicle}>
                                    <IonGrid>
                                        <IonRow>
                                            <IonCol size='6'>
                                                <IonInput fill='outline' name='vehicleLicense' placeholder='License' type='text' value={Vehicle.vehicleLicense}></IonInput>
                                            </IonCol>
                                            <IonCol size='6'>
                                                <IonSelect fill='outline' name='vehicleLicenseState' labelPlacement='stacked' placeholder='State' value={Vehicle.vehicleLicenseState}>
                                                    {Vehicle.vehicleLicenseState != '' ? (<IonSelectOption value=''>None</IonSelectOption>) : ''}
                                                    {states.map((state:any, index:number) => (
                                                        <IonSelectOption key={index} value={state[0]}>{state[1]}</IonSelectOption>
                                                    ))}
                                                </IonSelect>
                                            </IonCol>                                   
                                        </IonRow>
                                    </IonGrid>
                                    <IonButton className='ion-margin-top' color={'medium'} id='licenseFormCancel' onClick={toggleLicenseForm}>Cancel</IonButton>
                                    <IonButton className='ion-margin-top' color={'secondary'} id='licenseFormSubmit' type='submit'>Save</IonButton>
                                </form>)                                                     
                            : <p onClick={toggleLicenseForm}>{Vehicle.vehicleLicense == '' && Vehicle.vehicleLicenseState == '' ? 'Not Recorded' : Vehicle.vehicleLicense + ' ' + Vehicle.vehicleLicenseState}</p>
                        }
                    </IonCardContent>
                </IonCard>
                
                <IonCard className='ion-text-center'>
                    <IonCardContent>
                        <IonLabel color={'dark'}><b>Photo</b></IonLabel>   
                        <p className='ion-margin-top'>Photos must be .jpg format.</p>                     
                        <IonThumbnail>
                            {uploading
                                ? (<div className='no-user-photo'><IonSpinner name="crescent"></IonSpinner></div>)
                                : (Vehicle.vehiclePhoto == ''
                                    ? (<div className='no-user-photo' onClick={takePhoto}><IonIcon icon={cameraOutline}></IonIcon></div>)  
                                    : (<IonImg src={vehiclePhoto} onIonImgDidLoad={fadeInImage} />)
                                )
                            } 
                        </IonThumbnail>                                
                        {Vehicle.vehiclePhoto == ''
                            ? (<IonButton className='ion-margin' color={'secondary'} id='addPhoto' onClick={takePhoto}><IonIcon slot="start" icon={addCircleOutline}></IonIcon> Add Photo</IonButton>)
                            : (<>
                                <IonButton className='ion-margin' color={'secondary'} id='rotatePhoto' onClick={rotatePhoto} shape="round" size='default'><IonIcon icon={refreshOutline} slot='start'></IonIcon> Rotate</IonButton>
                                <IonButton className='ion-margin' color={'danger'} id='deletePhoto' onClick={deletePhoto} shape="round" size='default'><IonIcon icon={trashOutline} slot='start'></IonIcon> Delete</IonButton>
                                </>) 
                        } 
                    </IonCardContent>
                </IonCard>

                <div className='ion-text-center'>
                    <IonButton className='ion-margin delete-button-outline' color={'remove'} fill="outline" onClick={deleteVehicle}><IonIcon icon={trashOutline} slot='start'></IonIcon> Remove Vehicle</IonButton>
                </div>
                
            </IonContent>
        </IonPage>
    );
};

export default VehicleEdit;